import { render, staticRenderFns } from "./payoff.vue?vue&type=template&id=621bb6b5&"
import script from "./payoff.vue?vue&type=script&lang=js&"
export * from "./payoff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports